import DefaultCarousel from './DefaultCarousel'

export * from './DefaultCarousel'

export default DefaultCarousel
